function CssTransformer() {}
CssTransformer.prototype = {
  transform(stylesheet, window) {
    let styles = '';
    for (let i = 0; i < stylesheet.cssRules.length; i++) {
      let rule = stylesheet.cssRules[i];
      if (this._isStyleRule(rule)) {
        styles += this._processStyleRule(rule);
      }
      if (this._isMediaQueryRule(rule)) {
        styles += this._processMediaQueries(rule, window);
      }
      if (this._isImportRule(rule)) {
        styles += rule.cssText;
      }
    }
    return styles;
  },
  _isStyleRule(rule) {
    return rule.type === rule.STYLE_RULE;
  },
  _isMediaQueryRule(rule) {
    return rule.type === rule.MEDIA_RULE;
  },
  _isImportRule(rule) {
    return rule.type === rule.IMPORT_RULE;
  },
  _processStyleRule(rule) {
    return this._prependStyle(rule, 'div.ic-custom-html');
  },
  _processMediaQueries(rule, window) {
    let styles = '';
    let mediaString = rule.media[0] || rule.media.mediaText;
    if (this._shouldMediaQueryApplyToViewport(mediaString, window)) {
      for (let j = 0; j < rule.cssRules.length; j++) {
        let mediaQueryRule = rule.cssRules[j];
        styles += this._processStyleRule(mediaQueryRule);
      }
    }
    return styles;
  },
  _shouldMediaQueryApplyToViewport(mediaQuery, window) {
    return window.matchMedia(mediaQuery).matches;
  },
  _prependStyle(rule, prependWith) {
    let newSelectorText = `\n ${prependWith} ${rule.selectorText}`;
    newSelectorText = newSelectorText.replace(/,/g, `, ${prependWith}`);
    return rule.cssText.replace(rule.selectorText, newSelectorText).replace(`${prependWith} html`, prependWith).replace(/([^.]|^)body([ ,{.]+)/g, ' div.ic-custom-body$2') //don't match `.wrap.body`
    .replace(/div.ic-custom-html div.ic-custom-body/g, 'div.ic-custom-body');
  }
};
export default CssTransformer;